import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
// import { useSelector } from "react-redux";
import { admin_get_all_tags } from "../../endpoints/API";

export const fetchTestTag = async (setTestTags, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await admin_get_all_tags();
    if (response.statusText=="OK") {
      const data = response?.data;
      setTestTags(data);
    } else {
      message.error("Failed to fetch test tags.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching test tags.");
  }
};
